import { render } from "./qk-tree.vue?vue&type=template&id=40a98282&scoped=true"
import script from "./qk-tree.vue?vue&type=script&lang=js"
export * from "./qk-tree.vue?vue&type=script&lang=js"

import "./qk-tree.vue?vue&type=style&index=0&id=40a98282&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quick_wucode\\quick_wucode\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a98282"]])

export default __exports__